import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import Tabs from '@/components/molecules/Tabs';
import { useCageScopedSearch } from '@/contexts/cage-filter-context';

export default function HealthDeformitiesTabBar() {
    const { t } = useTranslation('healthModule');
    const location = useLocation();
    const search = useCageScopedSearch();

    const deformitiesBaseUrl = useMemo(
        () => location.pathname.replace(/\/(spine|jaw|gill-lid)$/, ''),
        [location.pathname]
    );

    const spinePath = `${deformitiesBaseUrl}/spine`;
    const jawPath = `${deformitiesBaseUrl}/jaw`;
    const gillLidPath = `${deformitiesBaseUrl}/gill-lid`;

    const items = [
        { value: 'spine', label: t('routes.spine'), path: spinePath },
        { value: 'jaw', label: t('routes.jaw'), path: jawPath },
        { value: 'gill-lid', label: t('routes.gillLid'), path: gillLidPath },
    ];

    // The links carry the cage-scoped params (`fg`); the active tab is matched on the path.
    return (
        <Tabs
            items={items.map(({ path, ...item }) => ({ ...item, to: `${path}${search}` }))}
            value={items.find((item) => location.pathname === item.path)?.value}
        />
    );
}
